/* pd-r4: design round B, phone first (2026-10-04, Abhi: "i like it build it on the preview").
   [R4-1] cookie bar: CSS only (assets/pd-r4.css)
   [R4-2] Diwali size shelves: the Diwali collection on phones as swipe shelves by size
   [R4-3] menu: each store's open/closed line (photo tiles removed 4 Oct)
   [R4-4] aisle rail: server-rendered (snippets/pd-aisle-rail.liquid)
   [R4-5] search: "Popular now" chips when the search opens empty; grouped results are server-rendered
          (sections/helper-predictive-search.liquid, snippets/pd-search-row.liquid)
   [R9-3] 5 Oct 2026: the diet filter runs in a View Transition (pd-r9.js window.pdGridVT)
   [R8-1] 5 Oct 2026: the phone filter sheet (Show N products, Clear all, Diet inside, chips above the grid)
   Loaded by sections/footer.liquid, so it runs before pd-r2.js. */
(function () {
  'use strict';
  var d = document, w = window;
  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function el(t, c, h) { var e = d.createElement(t); if (c) e.className = c; if (h != null) e.innerHTML = h; return e; }
  function safe(f) { try { f(); } catch (e) { if (w.console) console.warn('[pd-r4]', e); } }
  var PATH = location.pathname.replace(/\/$/, '') || '/';
  var CDN = 'https://cdn.shopify.com/s/files/1/0677/0724/0735/';
  var RM = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function img(path, wd) { return CDN + path + '?width=' + wd; }

  /* ---------- [R4-2] Diwali size shelves ----------
     The Diwali collection was ~22 phone screens of cards. On phones the same cards (with their steppers, List and Peek)
     are moved into one swipe shelf per size, so the whole range fits in about three screens. Sizes come from each
     card's own tag (custom.net_weight, snippets/product-item.liquid). A price filter in the URL ("See all", the size
     chips on desktop) keeps the plain grid. SHELF_SHARE sets how many phones get shelves: 1 on the preview; set 0.5
     for a live A/B, the choice sits on <html data-pd-shelf> for the funnel tracker. ?shelves=0|1 forces it. */
  var SHELF_SHARE = 0.5; /* live A/B from 4 Oct (Abhi: "Go live, shelves 50/50") */
  var SHELVES = [
    { k: 'lg', t: 'Large · 1 kg', n: 'for the family table', all: '/collections/diwali?filter.v.price.gte=30#pd-grid', m: /kg/ },
    { k: 'sm', t: 'Small · 500 g', n: 'for neighbours and friends', all: '/collections/diwali?filter.v.price.gte=20&filter.v.price.lte=29#pd-grid', m: /^500/ },
    { k: 'xs', t: 'Extra small · 250 g', n: 'for the long list', all: '/collections/diwali?filter.v.price.lte=15#pd-grid', m: /^250/ },
    { k: 'more', t: 'More Diwali boxes', n: 'packed for the date you choose' },
    { k: 'ev', t: 'Snacks & extras', n: 'these can join either order' }
  ];
  function shelfOn() {
    var f = location.search.match(/[?&]shelves=([01])/); if (f) return f[1] === '1';
    var v = null; try { v = w.localStorage.getItem('pd_shelf'); } catch (e) {}
    if (v !== 'on' && v !== 'off') { v = Math.random() < SHELF_SHARE ? 'on' : 'off'; try { w.localStorage.setItem('pd_shelf', v); } catch (e) {} }
    return v === 'on';
  }
  /* The A/B is read in the cart funnel collector (pure-desi-funnel.pages.dev, the same anonymous per-tab id as
     assets/pd-funnel.js, so a phone's Diwali-page visit joins its later cart steps). Two events, both with
     d = 'shelf:on' | 'shelf:off': dw_view (the Diwali page on a phone) and dw_add (a Pre-order tap on a card).
     Nothing personal; skipped when the shopper declined analytics in the cookie banner. */
  function shelfTrack(on) {
    if (!w.fetch) return;
    var cp = w.Shopify && w.Shopify.customerPrivacy;
    if (cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed() === false) return;
    var sid; try { sid = w.sessionStorage.getItem('pd-ft'); } catch (e) {}
    if (!sid) { sid = (Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2)).replace(/[^a-z0-9]/g, '').slice(0, 16); try { w.sessionStorage.setItem('pd-ft', sid); } catch (e) {} }
    var tag = 'shelf:' + (on ? 'on' : 'off'), ua = navigator.userAgent || '';
    var inapp = /Instagram/i.test(ua) ? 'ig' : (/FBAN|FBAV|FB_IAB|FBIOS/i.test(ua) ? 'fb' : '');
    function send(e, beacon) {
      var body = JSON.stringify({ e: e, sid: sid, mode: d.body.getAttribute('data-pd-mode') || '', inapp: inapp, dev: 'phone', d: tag });
      try {
        if (beacon && navigator.sendBeacon) { navigator.sendBeacon('https://pure-desi-funnel.pages.dev/api/e', new Blob([body], { type: 'text/plain' })); return; }
        w.fetch('https://pure-desi-funnel.pages.dev/api/e', { method: 'POST', body: body, headers: { 'Content-Type': 'text/plain' }, keepalive: true, mode: 'cors', credentials: 'omit' }).catch(function () {});
      } catch (err) {}
    }
    send('dw_view');
    d.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.product-item button, .product-item [type="submit"]');
      if (b && /pre-?order|add to/i.test(b.textContent || '')) send('dw_add', true);
    }, true);
  }
  function shelves() {
    if (PATH !== '/collections/diwali' || /filter\./.test(location.search) || /[?&]page=([2-9]|\d\d)/.test(location.search)) return;
    if (!w.matchMedia('(max-width: 749px)').matches) return;
    var on = shelfOn(); d.documentElement.setAttribute('data-pd-shelf', on ? 'on' : 'off'); shelfTrack(on); if (!on) return;
    var grid = $('[id*="__product-grid"] .collection.grid'); if (!grid || $('.pd-shelves')) return;
    var items = $$('.product-item[data-js-product-item]', grid).filter(function (it) { return it.parentNode === grid; });
    if (items.length < 6) return;
    var groups = {};
    items.forEach(function (it) {
      var tag = $('.pd-card-tag--diwali', it), key = 'ev';
      if (tag) {
        var size = (tag.getAttribute('data-pd-size') || '').trim(); key = 'more';
        SHELVES.forEach(function (s) { if (key === 'more' && s.m && s.m.test(size)) key = s.k; });
      }
      (groups[key] = groups[key] || []).push(it);
    });
    var wrap = el('div', 'pd-shelves');
    SHELVES.forEach(function (s) {
      var list = groups[s.k]; if (!list || !list.length) return;
      var sec = el('section', 'pd-shelf'); sec.id = 'pd-shelf-' + s.k; sec.setAttribute('aria-label', s.t.replace(' · ', ', ') + ', ' + list.length + (list.length === 1 ? ' item' : ' items'));
      sec.innerHTML = '<div class="pd-shelf__head"><div class="pd-shelf__tt"><h2 class="pd-shelf__t">' + s.t + '</h2><p class="pd-shelf__n">' + s.n + '</p></div>'
        + (s.all && list.length > 2 ? '<a class="pd-shelf__all" href="' + s.all + '">See all ' + list.length + '<span aria-hidden="true"> &rarr;</span></a>' : '')
        + '</div><div class="pd-shelf__track"></div>' + (list.length > 2 ? '<div class="pd-shelf__bar" aria-hidden="true"><i></i></div>' : '');
      var track = $('.pd-shelf__track', sec), bar = $('.pd-shelf__bar i', sec);
      list.forEach(function (it) { track.appendChild(it); });
      wrap.appendChild(sec);
      if (bar) {
        var prog = function () { var f = track.scrollWidth > 0 ? (track.scrollLeft + track.clientWidth) / track.scrollWidth : 1; bar.style.transform = 'scaleX(' + Math.min(1, Math.max(.08, f)).toFixed(3) + ')'; };
        track.addEventListener('scroll', prog, { passive: true }); w.addEventListener('resize', prog); setTimeout(prog, 60);
      }
    });
    grid.parentNode.insertBefore(wrap, grid);
    grid.classList.add('pd-shelves-src');
    /* pd-qw's ready-made sets and its review quote sit inside the grid; keep them, between the shelves */
    var sets = $('.pdqw-sets', grid), quote = $('.pdqw-rev--band', grid), after1 = $('#pd-shelf-lg', wrap), after2 = $('#pd-shelf-sm', wrap);
    if (sets && after1) wrap.insertBefore(sets, after1.nextSibling);
    if (quote && after2) wrap.insertBefore(quote, after2.nextSibling);
    /* the size chips (hero and the bar that follows you down) jump to a shelf instead of reloading the page filtered */
    function keyOf(a) { var t = (a.textContent || '').toLowerCase(); return /250/.test(t) ? 'xs' : /500/.test(t) ? 'sm' : /1 ?kg/.test(t) ? 'lg' : /all/.test(t) ? 'lg' : null; }
    function mark(k) { $$('.pdqw-sizes a').forEach(function (a) { var on = keyOf(a) === k && !/all/i.test(a.textContent); if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); }); }
    d.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('.pdqw-sizes a, .hv__chips a'); if (!a) return;
      var k = keyOf(a), sec = k && $('#pd-shelf-' + k); if (!sec) return;
      e.preventDefault();
      w.scrollTo({ top: sec.getBoundingClientRect().top + w.pageYOffset - 56, behavior: RM ? 'auto' : 'smooth' });
    }, true);
    if (w.IntersectionObserver) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) mark(en.target.id.replace('pd-shelf-', '')); }); }, { rootMargin: '-40% 0px -55% 0px' });
      $$('.pd-shelf', wrap).forEach(function (s) { io.observe(s); });
    }
  }

  /* ---------- [R4-3] Menu: each store's open/closed line ----------
     The photo tiles were removed on 4 Oct (Abhi: "Remove the photo menu I don't like it"; the tile version is
     pd-r4-with-photo-menu.js.bak in the build folder). The store rows at the foot of the menu (pd-season-lines) still
     get the open/closed line the footer cards work out ([R3-foot] in pd-r2.js), copied in each time the menu opens. */
  var STORE_KEYS = { 'arndell park': 'arndell-park', 'kellyville': 'kellyville', 'campbellfield': 'melbourne', 'woodridge': 'brisbane' };
  function menuStatus(sb) {
    $$('.pd-menu-stores > div', sb).forEach(function (row) {
      var name = ($('strong', row) || {}).textContent || '', key = STORE_KEYS[name.trim().toLowerCase()];
      var src = key && $('.pd-ft-store[data-pd-store="' + key + '"] .pd-ft-store__open'); if (!src || !src.textContent.trim()) return;
      var out = $('.pd-ms-open', row); if (!out) { out = el('span', 'pd-ms-open'); row.appendChild(out); }
      out.textContent = src.textContent.trim(); out.classList.toggle('is-open', src.classList.contains('is-open'));
    });
  }
  function photoMenu() {
    var sb = d.getElementById('site-menu-sidebar'); if (!sb || sb.getAttribute('data-r4m')) return;
    sb.setAttribute('data-r4m', '1');
    var was = false;
    new MutationObserver(function () {
      var now = sb.classList.contains('sidebar--opened') || sb.getAttribute('aria-hidden') === 'false' || sb.classList.contains('active');
      if (now && !was) safe(function () { menuStatus(sb); });
      was = now;
    }).observe(sb, { attributes: true, attributeFilter: ['aria-hidden', 'class', 'style'] });
  }

  /* ---------- [R4-5] Search: "Popular now" when the search opens empty ----------
     The theme fills [data-js-search-results] as you type (helper-predictive-search) and empties it when the field is
     cleared; these chips fill the empty state. Sweets are searched; boxes go straight to their collection. */
  var POP = [['Diwali boxes', '/collections/diwali'], ['Kaju katli', '/search?q=kaju+katli'], ['Motichoor ladoo', '/search?q=motichoor+ladoo'], ['Gulab jamun', '/search?q=gulab+jamun'], ['Burfi', '/search?q=burfi'], ['Gift boxes', '/collections/gift-boxes']];
  function popular() {
    $$('search-form').forEach(function (f) {
      var inp = $('[data-js-search-input]', f), out = $('[data-js-search-results]', f); if (!inp || !out || f.getAttribute('data-pd-pop')) return;
      f.setAttribute('data-pd-pop', '1');
      var html = '<div class="search-results pd-pop" data-js-search-results-holder><div class="search-block pd-sq"><span class="search-title pd-sg__h">Popular now</span>'
        + POP.map(function (p) { return '<a class="search-item pd-sq__chip" href="' + p[1] + '" data-js-search-item>' + p[0] + '</a>'; }).join('') + '</div></div>';
      function show() { if (!inp.value.trim() && !$('.search-results', out)) out.innerHTML = html; }
      inp.addEventListener('focus', show);
      inp.addEventListener('input', function () { if (!inp.value.trim()) setTimeout(show, 220); });
    });
  }

  /* ---------- [R7-2] Gluten free / Vegan filter on collection grids (2026-10-05, Abhi: "do all on the preview") ----------
     Cards carry data-pd-diet="gf vg" (snippets/product-item.liquid: every sweet in What's inside is marked Gluten free /
     Vegan). The bar sits above the grid (or the Diwali shelves). With a filter on, later pages of the collection are fetched
     once and their matching cards join the grid, and the page links hide; "All" puts everything back. Styles: pd-r7.css. */
  var DIET = null; /* [R8-1] the diet filter's handle for the filter sheet */
  function dietBar() {
    if (!/^\/collections\/[^/]+\/?$/.test(location.pathname) || $('.pd-diet-bar')) return;
    if (!$('#main-collection-product-grid')) return;
    var cards = $$('.product-item[data-pd-diet]'); if (cards.length < 4) return;
    var has = function (c, k) { return (' ' + (c.getAttribute('data-pd-diet') || '') + ' ').indexOf(' ' + k + ' ') > -1; };
    var gfN = cards.filter(function (c) { return has(c, 'gf'); }).length, vgN = cards.filter(function (c) { return has(c, 'vg'); }).length;
    if (!gfN && !vgN) return;
    var bar = d.createElement('div'); bar.className = 'pd-diet-bar'; bar.setAttribute('role', 'group'); bar.setAttribute('aria-label', 'Filter by diet');
    bar.innerHTML = '<span class="pd-diet-bar__l">Diet</span><button type="button" data-k="" aria-pressed="true">All</button>'
      + (gfN ? '<button type="button" data-k="gf" aria-pressed="false">Gluten free</button>' : '')
      + (vgN ? '<button type="button" data-k="vg" aria-pressed="false">Vegan</button>' : '')
      + '<p class="pd-diet-bar__note" aria-live="polite"></p>';
    /* [R8-1] the bar sits just outside #CollectionProductGrid, which the theme's filter script redraws on every filter change */
    var wrap = d.getElementById('CollectionProductGrid');
    function place() {
      if (bar.parentNode) return;
      var anchor = $('.pd-shelves') || wrap || $('#main-collection-product-grid');
      anchor.parentNode.insertBefore(bar, anchor);
    }
    place();
    var note = $('.pd-diet-bar__note', bar), more = null, key = '', shown = 0;
    function pager() { return $('#CollectionProductGrid .pagination') || $('.pagination') || $('[class*="pagination"]'); }
    function pageUrls() {
      var pg = pager(), links = pg ? $$('a[href*="page="]', pg) : [], max = 1;
      links.forEach(function (a) { var m = a.getAttribute('href').match(/[?&]page=(\d+)/); if (m) max = Math.max(max, +m[1]); });
      var cur = +(new URLSearchParams(location.search).get('page') || 1), out = [];
      for (var i = 1; i <= Math.min(max, 4); i++) if (i !== cur) { var u = new URL(location.href); u.searchParams.set('page', i); out.push(u.toString()); }
      return out;
    }
    function fetchRest() {
      if (more) return more;
      var shelves = $('.pd-shelves');
      var target = shelves ? ($('#pd-shelf-ev .pd-shelf__track') || $$('.pd-shelf__track').pop()) : $('#main-collection-product-grid');
      more = Promise.all(pageUrls().map(function (u) {
        return fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (h) {
          if (!h) return;
          var doc = new DOMParser().parseFromString(h, 'text/html');
          $$('#main-collection-product-grid .product-item[data-pd-diet]', doc).forEach(function (c) {
            if (d.getElementById(c.id)) return;
            var n = d.importNode(c, true); n.setAttribute('data-pd-more', '1');
            $$('img', n).forEach(function (im) { im.addEventListener('load', function () { im.parentNode.classList.add('lazyloaded'); }); if (im.complete && im.naturalWidth) im.parentNode.classList.add('lazyloaded'); });
            if (target) target.appendChild(n);
          });
        }).catch(function () {});
      }));
      return more;
    }
    function emit() { try { d.dispatchEvent(new CustomEvent('pd:diet', { detail: { k: key, shown: shown } })); } catch (e) {} }
    function apply(k) {
      key = k;
      $$('button', bar).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-k') === k ? 'true' : 'false'); });
      var all = $$('.product-item[data-pd-diet]'); shown = 0;
      all.forEach(function (c) {
        var out = k ? !has(c, k) : c.hasAttribute('data-pd-more');
        c.classList.toggle('pd-diet-out', out); if (!out) shown++;
      });
      $$('.pd-shelf').forEach(function (s) { s.classList.toggle('pd-diet-empty', !$$('.product-item:not(.pd-diet-out)', s).length && !!k); });
      var pg = pager(); if (pg) pg.style.display = k ? 'none' : '';
      note.textContent = k ? shown + (k === 'gf' ? ' gluten free' : ' vegan') + ', going by each sweet’s ingredients. Ask in store if you need a strict allergen check.' : '';
      emit();
    }
    /* [R9-3] the change runs in a View Transition when pd-r9.js offers one: kept cards glide, the rest fade */
    function vtApply(k) { (w.pdGridVT || function (f) { f(); })(function () { apply(k); }); }
    function choose(k) {
      if (k && pager()) { key = k; note.textContent = 'Finding them…'; return fetchRest().then(function () { vtApply(k); }); }
      vtApply(k); return Promise.resolve();
    }
    bar.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-k]'); if (!b) return;
      choose(b.getAttribute('data-k'));
    });
    /* [R8-1] a filter change redraws the grid with fresh cards and a fresh pager: forget the fetched pages and apply the diet again */
    if (wrap && w.MutationObserver) new MutationObserver(function () { more = null; place(); if (key) choose(key); else emit(); }).observe(wrap, { childList: true });
    DIET = { choose: choose, key: function () { return key; }, shown: function () { return shown; }, gf: gfN > 0, vg: vgN > 0 };
  }

  /* ---------- [R8-1] Phone filter sheet (5 Oct 2026, Abhi: "do the recommended") ----------
     "Filter and sort" opened a panel with only an X: no count, no way to clear, and the Diet filter was not in it. Now (markup in
     sections/main-collection-product-grid.liquid, look in assets/pd-r7.css [R8-1]):
     - phones get it as a bottom sheet (drag the top edge down to close); tablets keep the side panel
     - a bar at the bottom: "Show 29 products", counted again on every change and read out to screen readers, and "Clear all"
     - the Diet choices sit at the top of the sheet, in step with the bar above the grid
     - the sheet is named for screen readers, takes focus when it opens, keeps Tab inside, and hands focus back when it closes
     - the removable chips above the grid (phones and tablets) redraw the grid in place instead of reloading the page */
  function PHONE() { return !!(w.matchMedia && w.matchMedia('(max-width:767px)').matches); }
  function filterSheet() {
    var sb = d.getElementById('site-filters-sidebar'); if (!sb) return;
    var foot = $('.pd-fs__foot', sb); if (!foot) return;
    var label = $('[data-pd-fs-label]', sb), live = $('[data-pd-fs-live]', sb), clr = $('[data-pd-fs-clear]', sb), show = $('[data-pd-fs-show]', sb), body = $('.sidebar__body', sb);
    var wrap = d.getElementById('CollectionProductGrid');
    var FF = function () { var c = w.customElements && customElements.get('facet-filters-form'); return c && c.renderPage ? c : null; };
    var diet = null;
    function buildDiet() {
      if (diet || !DIET || !body) return;
      diet = el('div', 'pd-fs__diet', '<p class="pd-fs__h" id="pd-fs-diet">Diet</p><div class="pd-fs__chips" role="group" aria-labelledby="pd-fs-diet">'
        + '<button type="button" data-k="" aria-pressed="true">All</button>'
        + (DIET.gf ? '<button type="button" data-k="gf" aria-pressed="false">Gluten free</button>' : '')
        + (DIET.vg ? '<button type="button" data-k="vg" aria-pressed="false">Vegan</button>' : '') + '</div>');
      body.insertBefore(diet, body.firstChild);
      diet.addEventListener('click', function (e) { var b = e.target.closest('button[data-k]'); if (!b) return; label.textContent = 'Updating…'; DIET.choose(b.getAttribute('data-k')); });
    }
    function facetCount() { var c = $('#CollectionProductGrid [data-pd-chips]'); return c ? +c.getAttribute('data-pd-chips') || 0 : 0; }
    function count() {
      if (DIET && DIET.key()) return DIET.shown();
      var m = $('#CollectionProductGrid [data-pd-count]'); return m ? +m.getAttribute('data-pd-count') : null;
    }
    var last = null, sayT = 0;
    function paint(say) {
      var n = count(); if (n == null || isNaN(n)) return;
      var k = DIET ? DIET.key() : '';
      label.textContent = n === 0 ? 'No products match' : 'Show ' + n + (n === 1 ? ' product' : ' products');
      clr.disabled = !(facetCount() || k);
      if (diet) $$('button', diet).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-k') === k ? 'true' : 'false'); });
      if (say && sb.classList.contains('sidebar--opened')) {
        clearTimeout(sayT);
        sayT = setTimeout(function () { live.textContent = ''; setTimeout(function () { live.textContent = n === 0 ? 'No products match these filters' : n + (n === 1 ? ' product' : ' products'); }, 60); }, 280);
      }
      last = n;
    }
    paint(false);
    sb.addEventListener('input', function (e) { if (e.target && e.target.closest('facet-filters-form')) label.textContent = 'Updating…'; });
    if (wrap && w.MutationObserver) new MutationObserver(function () { paint(true); }).observe(wrap, { childList: true });
    d.addEventListener('pd:diet', function () { paint(true); });
    clr.addEventListener('click', function () {
      if (DIET && DIET.key()) DIET.choose('');
      var F = FF();
      if (facetCount() && F) {
        var sp = new URLSearchParams(location.search), keep = new URLSearchParams();
        if (sp.get('sort_by')) keep.set('sort_by', sp.get('sort_by'));
        label.textContent = 'Updating…'; F.renderPage(keep.toString());
      }
      paint(true);
      try { show.focus({ preventScroll: true }); } catch (e) {} /* Clear all turns itself off: keep focus in the sheet */
    });
    show.addEventListener('click', function () {
      if (sb.hide) sb.hide();
      var top = $('.pd-diet-bar') || wrap; if (!top) return;
      var y = top.getBoundingClientRect().top + w.pageYOffset - 96;
      if (y < w.pageYOffset) w.scrollTo({ top: Math.max(0, y), behavior: RM ? 'auto' : 'smooth' });
    });
    /* open/close: name, focus in, keep Tab inside, focus back */
    var opener = null, wasOpen = false;
    new MutationObserver(function () {
      var open = sb.classList.contains('sidebar--opened');
      if (open && !wasOpen) {
        opener = d.activeElement; buildDiet(); paint(false);
        setTimeout(function () { if (!sb.contains(d.activeElement)) sb.focus({ preventScroll: true }); }, 40);
      } else if (!open && wasOpen) {
        sb.setAttribute('aria-hidden', 'true');
        var o = opener; opener = null;
        if (o && o.focus && d.body.contains(o)) setTimeout(function () { try { o.focus({ preventScroll: true }); } catch (e) {} }, 340);
      }
      wasOpen = open;
    }).observe(sb, { attributes: true, attributeFilter: ['class'] });
    sb.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, summary, [tabindex]:not([tabindex="-1"])', sb).filter(function (x) { return x.offsetParent !== null || x === d.activeElement; });
      if (!f.length) return;
      var first = f[0], lastEl = f[f.length - 1];
      if (e.shiftKey && (d.activeElement === first || d.activeElement === sb)) { e.preventDefault(); lastEl.focus(); }
      else if (!e.shiftKey && d.activeElement === lastEl) { e.preventDefault(); first.focus(); }
    });
    /* phones: drag the sheet's top edge down to close it */
    var hdr = $('.sidebar__header', sb), y0 = null, dy = 0;
    if (hdr) {
      hdr.addEventListener('touchstart', function (e) { if (!PHONE() || e.touches.length !== 1) return; y0 = e.touches[0].clientY; dy = 0; sb.style.setProperty('transition', 'none', 'important'); }, { passive: true });
      hdr.addEventListener('touchmove', function (e) { if (y0 == null) return; dy = Math.max(0, e.touches[0].clientY - y0); sb.style.setProperty('transform', 'translateY(' + dy + 'px)', 'important'); }, { passive: true });
      var end = function () { if (y0 == null) return; y0 = null; sb.style.removeProperty('transition'); sb.style.removeProperty('transform'); if (dy > 90 && sb.hide) sb.hide(); dy = 0; };
      hdr.addEventListener('touchend', end); hdr.addEventListener('touchcancel', end);
    }
    /* the chips above the grid, and the theme's chips inside the sheet: redraw in place */
    d.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('#CollectionProductGrid .pd-chip, #site-filters-sidebar .active-facets a.js-facet-remove'); if (!a) return;
      var F = FF(); if (!F) return;
      e.preventDefault();
      var href = a.getAttribute('href') || '', i = href.indexOf('?');
      F.renderPage(i < 0 ? '' : href.slice(i + 1));
    });
  }

  /* [R7-4] Store pages: the icons and map get text alternatives (decorative icons: empty alt; the map: a title) */
  function storeA11y() {
    if (!/^\/pages\/(arndell-park|kellyville|melbourne|brisbane)\/?$/.test(location.pathname)) return;
    $$('.main-location img:not([alt]), .location-section img:not([alt]), .main-location ~ * img:not([alt])').forEach(function (i) { i.setAttribute('alt', ''); });
    $$('iframe[src*="google.com/maps"]:not([title])').forEach(function (f) { f.setAttribute('title', 'Map: ' + (d.title || 'Pure Desi store').split('|')[0].trim()); });
  }

  /* [QA 4 Oct] Esc closed the desktop search results but left the page dimmed under the overlay until a click */
  d.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    var t = e.target; if (!t || !t.matches || !t.matches('[data-js-search-input]')) return;
    setTimeout(function () { $$('.search-results-overlay.active').forEach(function (o) { o.classList.remove('active'); }); }, 0);
  });

  /* menu and search right away; the shelves wait for DOMContentLoaded, which fires after every deferred script, so pd-qw
     (loaded later) has already sorted the grid and added its sets and quote */
  function run() { safe(photoMenu); safe(popular); safe(storeA11y); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', run); else run();
  var shelved = false; function shelfOnce() { if (!shelved) { shelved = true; safe(shelves); safe(dietBar); safe(filterSheet); } }
  if (d.readyState === 'complete') shelfOnce(); else { d.addEventListener('DOMContentLoaded', function () { setTimeout(shelfOnce, 0); }); w.addEventListener('load', shelfOnce); }
})();
